// extracted by mini-css-extract-plugin
module.exports = {"container":"dividends-recieved_container__3YaTV","arrows":"dividends-recieved_arrows__1pObP"};